import { FeatherIcon } from '../components/FeatherIcon'

/** The list panel's search box (design: 38px, icon + input). */
export function PanelSearch({ label, value, onChange }: { label: string; value: string; onChange: (v: string) => void }) {
  return (
    <div className="lib-search">
      <FeatherIcon name="search" size={15} className="lib-search-icon" />
      <input
        type="search"
        className="lib-search-input"
        aria-label={label}
        placeholder={`${label}…`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
}
